module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/quote-comments-aside/quote-comments-aside.component.scss
// module id = 639
// module chunks = 0